import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table } from "antd";

class SpaceStorageGoodsModal extends Component {
  state = {
    loading: false,
    item: null,
    items: [],
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "儲位編號",
        dataIndex: "StorageCode",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "儲位名稱",
        dataIndex: "StorageName",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "物品編號",
        dataIndex: "ThingId",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "物品名稱",
        dataIndex: "ThingName",
        width: 40,
        responsive: ["md"],
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading } = this.state;
    const { goods } = this.props;
    //console.log(goods);
    return (
      <Card>
        <Table
          dataSource={goods}
          columns={this.columns}
          loading={loading}
          scroll={{ y: 460 }}
          width="60%"
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceStorageGoodsModal);
